<template>
  <v-combobox
    @change="$emit('attrUpdate', $event)"
    :value="initialIntervals"
    :label="$t('experiment-rows')"
    :prepend-inner-icon="mdiArrowExpandHorizontal"
    :hint="$t('experiment-rows-hint')"
    :rules="chipsRules"
    placeholder="0000–0000"
    autocomplete="off"
    deletable-chips
    persistent-hint
    append-icon
    small-chips
    multiple
    outlined
    counter
    flat
  >
    <template v-slot:message>
      <div class="mb-4" v-html="$t('experiment-rows-hint')"></div>
    </template>
  </v-combobox>
</template>

<script>
import { mdiArrowExpandHorizontal } from "@mdi/js";
export default {
  name: "FieldIntervals",
  props: { initialIntervals: Array, required: Boolean },
  data: (vm) => ({
    mdiArrowExpandHorizontal,
    chipsRules: [(v) => v.length > 0 || vm.$t("field-requied")],
  }),
};
</script>
